import http from "@/http-common";
import './security';

class DeviceService {
  getAll() {
    return http.get("/device");
  }

  getSensorCount(iddevice) {
    return http.get(`/device/sensor/${iddevice}`);
  }

  getDevicesFromLocation(locationid) {
    return http.get(`/device/locationid/${locationid}`);
  }

  get(id) {    
    return http.get(`/device/id/${id}`);
  }

  create(data) {
    return http.post("/device", data);
  }

  update(data) {
    return http.put(`/device/id/${data._id}`, data);
  }

  findByAlias(alias) {
    if (!alias) {
      return http.get("/device", data);
    } else {
      return http.get(`/device/alias?alias=${alias}`);
    }
  }

  delete(id, sensorFlag) {
    const data = {
      deleteSensorFlag: sensorFlag ? sensorFlag : false
    }    
    return http.delete(`/device/id/${id}`, {data});
  }

  deleteAll() {
    return http.delete(`/device`);
  }

  getGPS(id){
    return http.get(`/device/gps/id/${id}`);
  }

  getSpecType(){
    return http.get("/device/type");
  }

  getSpecTypeKeyAlias(){
    return http.get("/device/type/keyalias");
  }

  getDeviceFilterGroup(){
    return http.get("/device/filter/architecture");
  }

  saveDeviceFilterGroup(data){
    return http.post("/device/filter/architecture", data);
  }

  getPressureDeviceData(){
    return http.get("/device/filter");
  }

  getPressureSensorFromUuid(uuid){
    return http.get(`/device/filter/sensor/${uuid}`);
  }

}

export default new DeviceService();
